webpackJsonp([1],{

/***/ 294:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify__ = __webpack_require__(593);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vuetify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vuetify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetify_dist_vuetify_css__ = __webpack_require__(568);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_vuetify_dist_vuetify_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_vuetify_dist_vuetify_css__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App__ = __webpack_require__(576);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__App___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__App__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__router__ = __webpack_require__(318);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__api_AVPublicAPI__ = __webpack_require__(313);
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.









__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vuetify___default.a);
// Vue.config.productionTip = false

var api = new __WEBPACK_IMPORTED_MODULE_5__api_AVPublicAPI__["a" /* default */]("https://portal.fdatek.de/api");
Object.defineProperty(__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].prototype, '$api', {
  get: function get() {
    return api;
  }
});

/* eslint-disable no-new */
new __WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */]({
  el: '#app',
  router: __WEBPACK_IMPORTED_MODULE_4__router__["a" /* default */],
  template: '<App/>',
  components: {
    App: __WEBPACK_IMPORTED_MODULE_3__App___default.a
  }
});

/***/ }),

/***/ 313:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__(329);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_axios__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__CommunicationApi__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__OrderApi__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__ServiceApi__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__UserApi__ = __webpack_require__(317);










var _class = function () {
    function _class(baseurl) {
        var _this = this;

        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, _class);

        __WEBPACK_IMPORTED_MODULE_3_axios___default.a.defaults.baseURL = baseurl;
        this.timeoutLogoff = false;
        this.listeners = [];
        this.communication = new __WEBPACK_IMPORTED_MODULE_4__CommunicationApi__["a" /* default */](this);
        this.order = new __WEBPACK_IMPORTED_MODULE_5__OrderApi__["a" /* default */](this);
        this.service = new __WEBPACK_IMPORTED_MODULE_6__ServiceApi__["a" /* default */](this);
        this.user = new __WEBPACK_IMPORTED_MODULE_7__UserApi__["a" /* default */](this);
        __WEBPACK_IMPORTED_MODULE_3_axios___default.a.interceptors.response.use(function (response) {
            _this.setToken(response.headers['x-token']);
            return response;
        }, function (error) {
            var errorMessage = '';
            if (error.request.responseType === 'arraybuffer') {
                var enc = new TextDecoder();
                errorMessage = JSON.parse(enc.decode(error.response.data)).error;
            } else {
                errorMessage = error.response.data.error;
            }
            _this.dispatchEvent(new CustomEvent('error', {
                target: _this,
                detail: errorMessage
            }));
            return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a.reject(error);
        });
        var token = window.sessionStorage.getItem('jwt');
        if (token) this.login({ jwt: token });
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(_class, [{
        key: 'addEventListener',
        value: function addEventListener(type, callback) {
            if (!(type in this.listeners)) {
                this.listeners[type] = [];
            }
            this.listeners[type].push(callback);
        }
    }, {
        key: 'removeEventListener',
        value: function removeEventListener(type, callback) {
            if (!(type in this.listeners)) {
                return;
            }
            var stack = this.listeners[type];
            for (var i = 0, l = stack.length; i < l; i++) {
                if (stack[i] === callback) {
                    stack.splice(i, 1);
                    return;
                }
            }
        }
    }, {
        key: 'dispatchEvent',
        value: function dispatchEvent(event) {
            if (!(event.type in this.listeners)) {
                return true;
            }
            var stack = this.listeners[event.type];
            for (var i = 0, l = stack.length; i < l; i++) {
                stack[i].call(this, event);
            }
            return !event.defaultPrevented;
        }
    }, {
        key: 'setToken',
        value: function setToken(token) {
            var _this2 = this;

            if (!token) return;
            if (this.timeoutLogoff) {
                window.clearTimeout(this.timeoutLogoff);
                this.timeoutLogoff = false;
            }
            var jwtDecode = __webpack_require__(572);
            var jwt = jwtDecode(token);
            __WEBPACK_IMPORTED_MODULE_3_axios___default.a.defaults.headers.common['Authorization'] = 'Bearer ' + token;
            if (jwt.exp) {
                var diff = jwt.exp * 1000 - Date.now();
                if (diff <= 0) diff = 0;
                this.timeoutLogoff = window.setTimeout(function () {
                    _this2.logout();
                }, diff);
            }
            window.sessionStorage.setItem('jwt', token);
            return jwt;
        }
    }, {
        key: 'login',
        value: function login(params) {
            var _this3 = this;

            return this.user.login(params).then(function (response) {
                var jwt = _this3.setToken(response.data.jwt);
                _this3.dispatchEvent(new CustomEvent('login', { target: _this3, jwt: jwt }));
            });
        }
    }, {
        key: 'logout',
        value: function logout() {
            if (this.timeoutLogoff) {
                window.clearTimeout(this.timeoutLogoff);
                this.timeoutLogoff = false;
            }
            delete __WEBPACK_IMPORTED_MODULE_3_axios___default.a.defaults.headers.common['Authorization'];
            window.sessionStorage.removeItem('jwt');
            this.dispatchEvent(new CustomEvent('logout', { target: this }));
        }
    }]);

    return _class;
}();

/* harmony default export */ __webpack_exports__["a"] = (_class);

/***/ }),

/***/ 314:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);




var CommunicationApi = function () {
    function CommunicationApi(api) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, CommunicationApi);

        this.$api = api;
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(CommunicationApi, [{
        key: 'findMessage',
        value: function findMessage() {
            return __WEBPACK_IMPORTED_MODULE_2_axios___default()({ url: '/communication/Message' });
        }
    }, {
        key: 'postMessage',
        value: function postMessage(Message) {
            return __WEBPACK_IMPORTED_MODULE_2_axios___default()({ url: '/communication/Message', method: 'post', data: Message });
        }
    }]);

    return CommunicationApi;
}();

/* harmony default export */ __webpack_exports__["a"] = (CommunicationApi);

/***/ }),

/***/ 315:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);




var OrderApi = function () {
    function OrderApi(api) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, OrderApi);

        this.$api = api;
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(OrderApi, [{
        key: 'findInvoice',
        value: function findInvoice() {
            return __WEBPACK_IMPORTED_MODULE_2_axios___default()({ url: '/order/Invoice' });
        }
    }, {
        key: 'invoiceDownload',
        value: function invoiceDownload(params) {
            return __WEBPACK_IMPORTED_MODULE_2_axios___default()({ url: '/order/invoiceDownload', method: 'post', data: params, responseType: 'arraybuffer' }).then(function (response) {
                var blob = new Blob([response.data], { type: 'application/pdf' });
                var link = document.createElement('a');
                var e = document.createEvent('MouseEvents');
                link.href = window.URL.createObjectURL(blob);
                link.download = response.headers['x-filename'];
                e.initMouseEvent('click', true, false, window, 0, 0, 0, 0, 0, false, false, false, false, 0, null);
                link.dispatchEvent(e);
            });
        }
    }]);

    return OrderApi;
}();

/* harmony default export */ __webpack_exports__["a"] = (OrderApi);

/***/ }),

/***/ 316:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);




var ServiceApi = function () {
    function ServiceApi(api) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, ServiceApi);

        this.$api = api;
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(ServiceApi, [{
        key: 'findServiceOrder',
        value: function findServiceOrder() {
            return __WEBPACK_IMPORTED_MODULE_2_axios___default()({ url: '/service/ServiceOrder' });
        }
    }]);

    return ServiceApi;
}();

/* harmony default export */ __webpack_exports__["a"] = (ServiceApi);

/***/ }),

/***/ 317:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(57);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(58);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_axios___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_axios__);




var UserApi = function () {
    function UserApi(api) {
        __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, UserApi);

        this.$api = api;
    }

    __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(UserApi, [{
        key: 'login',
        value: function login(params) {
            return __WEBPACK_IMPORTED_MODULE_2_axios___default()({ url: '/user/login', method: 'post', data: params });
        }
    }, {
        key: 'register',
        value: function register(params) {
            return __WEBPACK_IMPORTED_MODULE_2_axios___default()({ url: '/user/register', method: 'post', data: params });
        }
    }, {
        key: 'logout',
        value: function logout(params) {
            return __WEBPACK_IMPORTED_MODULE_2_axios___default()({ url: '/user/logout', method: 'post', data: params });
        }
    }, {
        key: 'accountGetInfo',
        value: function accountGetInfo(params) {
            return __WEBPACK_IMPORTED_MODULE_2_axios___default()({ url: '/user/accountGetInfo', method: 'post', data: params });
        }
    }, {
        key: 'accountUpdate',
        value: function accountUpdate(params) {
            return __WEBPACK_IMPORTED_MODULE_2_axios___default()({ url: '/user/accountUpdate', method: 'post', data: params });
        }
    }]);

    return UserApi;
}();

/* harmony default export */ __webpack_exports__["a"] = (UserApi);

/***/ }),

/***/ 318:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__(121);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_router__ = __webpack_require__(590);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_account_AccountOverview__ = __webpack_require__(578);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_account_AccountOverview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_account_AccountOverview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_order_OrderOverview__ = __webpack_require__(580);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_order_OrderOverview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_order_OrderOverview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_service_ServiceOrderOverview__ = __webpack_require__(582);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_service_ServiceOrderOverview___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_service_ServiceOrderOverview__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_communication_Messages__ = __webpack_require__(579);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_communication_Messages___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_communication_Messages__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_portal_Dashboard__ = __webpack_require__(581);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_portal_Dashboard___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_portal_Dashboard__);








__WEBPACK_IMPORTED_MODULE_0_vue__["a" /* default */].use(__WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]);

/* harmony default export */ __webpack_exports__["a"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_router__["a" /* default */]({
  routes: [{
    path: '/',
    name: 'Dashboard',
    component: __WEBPACK_IMPORTED_MODULE_6__components_portal_Dashboard___default.a
  }, {
    path: '/AccountOverview',
    name: 'AccountOverview',
    component: __WEBPACK_IMPORTED_MODULE_2__components_account_AccountOverview___default.a
  }, {
    path: '/ServiceOrderOverview',
    name: 'ServiceOrderOverview',
    component: __WEBPACK_IMPORTED_MODULE_4__components_service_ServiceOrderOverview___default.a
  }, {
    path: '/OrderOverview',
    name: 'OrderOverview',
    component: __WEBPACK_IMPORTED_MODULE_3__components_order_OrderOverview___default.a
  }, {
    path: '/Messages',
    name: 'Messages',
    component: __WEBPACK_IMPORTED_MODULE_5__components_communication_Messages___default.a
  }]
}));

/***/ }),

/***/ 319:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Login__ = __webpack_require__(577);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Login___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__Login__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue__ = __webpack_require__(121);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//




var appData = {
  clipped: false,
  drawer: true,
  fixed: false,
  isLoggedIn: false,
  items: [{
    icon: 'dashboard',
    title: 'Übersicht',
    link: '/'
  }, {
    icon: 'build',
    title: 'Werkstattaufträge',
    link: '/ServiceOrderOverview'
  }, {
    icon: 'business_center',
    title: 'Einkäufe',
    link: '/OrderOverview'
  }, {
    icon: 'local_post_office',
    title: 'Nachrichten',
    link: '/Messages'
  }, {
    icon: 'chat',
    title: 'Chat',
    link: '/Chat'
  }, {
    icon: 'account_circle',
    title: 'Mein Konto',
    link: '/AccountOverview'
  }],
  miniVariant: false,
  right: true,
  rightDrawer: false,
  title: 'freeline Kundenportal',
  error: false,

  // login page
  account: {
    username: '',
    password: '',
    name: '',
    invoice_date: '',
    invoice_nr: '',
    invoice_total: '',
    customer_nr: '',
    phone: '',
    email: ''
  },
  login_selected_tab: 'login'
};

__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].component('v-login', __WEBPACK_IMPORTED_MODULE_0__Login___default.a);
Object.defineProperty(__WEBPACK_IMPORTED_MODULE_1_vue__["a" /* default */].prototype, '$appData', {
  get: function get() {
    return appData;
  }
});

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return appData;
  },
  created: function created() {
    var _this = this;

    this.$api.addEventListener('login', function () {
      _this.$appData.isLoggedIn = true;
      _this.$api.user.accountGetInfo().then(function (response) {
        _this.$appData.account = response.data;
      });
    });
    this.$api.addEventListener('logout', function () {
      _this.$appData.isLoggedIn = false;
    });
    this.$api.addEventListener('error', function (event) {
      _this.$appData.error = event.detail;
    });
  },

  methods: {
    logout: function logout(event) {
      this.$api.logout();
    },
    closeError: function closeError(event) {
      this.$appData.error = false;
    }
  }
});

/***/ }),

/***/ 320:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray__);

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      e1: true,
      date: null,
      dateFormatted: null,
      menu: null
    };
  },
  created: function created() {
    if (this.$route.query.jwt) {
      this.$api.login({
        jwt: this.$route.query.jwt
      });
      this.$router.push('/');
    }
  },

  methods: {
    login: function login(event) {
      this.$api.login({
        username: this.$appData.account.username,
        password: this.$appData.account.password
      });
    },
    register: function register(event) {
      var _this = this;

      this.$api.user.register(this.$appData.account).then(function (response) {
        if (response.data && response.data.jwt) {
          _this.$api.login({
            jwt: response.data.jwt
          });
        }
      });
    },
    formatDate: function formatDate(date) {
      if (!date) {
        return null;
      }

      var _date$split = date.split('-'),
          _date$split2 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_date$split, 3),
          year = _date$split2[0],
          month = _date$split2[1],
          day = _date$split2[2];

      return day + '.' + month + '.' + year;
    },
    parseDate: function parseDate(date) {
      if (!date) {
        return null;
      }

      var _date$split3 = date.split('.'),
          _date$split4 = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_slicedToArray___default()(_date$split3, 3),
          day = _date$split4[0],
          month = _date$split4[1],
          year = _date$split4[2];

      return year + '-' + month.padStart(2, '0') + '-' + day.padStart(2, '0');
    }
  }
});

/***/ }),

/***/ 321:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      account: {
        username: '',
        email: '',
        password: '',
        changepwd: false
      },
      e1: true,
      items: [{
        icon: 'dashboard',
        text: 'Onlinezugang',
        link: '/Overview'
      }, {
        icon: 'exit_to_app',
        text: 'Kundenkonto',
        link: '/Logout'
      }]
    };
  },
  created: function created() {
    var _this = this;

    this.$api.user.accountGetInfo().then(function (response) {
      _this.account = response.data;
    });
  },

  methods: {
    updateAccount: function updateAccount(event) {
      var _this2 = this;

      this.$api.user.accountUpdate(this.account).then(function (response) {
        _this2.$appData.account.username = _this2.account.username;
        _this2.$appData.account.email = _this2.account.email;
      });
    }
  }
});

/***/ }),

/***/ 322:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue2_editor__ = __webpack_require__(592);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue2_editor___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue2_editor__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//



/* harmony default export */ __webpack_exports__["default"] = ({
  components: {
    VueEditor: __WEBPACK_IMPORTED_MODULE_0_vue2_editor__["VueEditor"]
  },
  data: function data() {
    return {
      hidden: false,
      messages: [],
      activeMessage: false,
      title: '',
      text: '',
      customToolbar: [['bold', 'italic', 'underline'], [{
        'list': 'ordered'
      }, {
        'list': 'bullet'
      }], ['image', 'code-block']]
    };
  },
  created: function created() {
    var _this = this;

    this.$api.communication.findMessage().then(function (response) {
      _this.messages = response.data.filter(function (element, index, array) {
        if (element.parent_message_id !== 0) return false;
        element.replies = array.filter(function (msg, i, a) {
          return msg.parent_message_id === element.message_id;
        });
        return true;
      });
      _this.$nextTick(function () {
        _this.scrollToEnd();
      });
    });
  },

  methods: {
    sendMessage: function sendMessage() {
      var _this2 = this;

      this.$api.communication.postMessage({
        message_title: this.title,
        message_body: {
          message_body: this.text
        }
      }).then(function (response) {
        _this2.messages.push(response.data);
        _this2.title = _this2.text = '';
        _this2.$nextTick(function () {
          _this2.scrollToEnd();
        });
      });
    },
    scrollToEnd: function scrollToEnd() {
      var container = document.getElementsByTagName('html')[0];
      container.scrollTop = container.scrollHeight;
    }
  }
});

/***/ }),

/***/ 323:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


__WEBPACK_IMPORTED_MODULE_0_moment___default.a.locale('de');

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      headers: [{
        text: 'Belegdatum',
        value: 'invoice_date'
      }, {
        text: 'Belegnummer',
        value: 'invoice_nr',
        align: 'right'
      }, {
        text: 'Belegtyp',
        value: 'invoice_type',
        align: 'left'
      }, {
        text: 'Betrag',
        value: 'total',
        align: 'right'
      }, {
        text: 'Beleg herunterladen',
        sortable: false
      }],
      invoices: [],
      pagination: {
        sortBy: 'invoice_date',
        descending: true,
        rowsPerPage: 10
      },
      moment: __WEBPACK_IMPORTED_MODULE_0_moment___default.a
    };
  },
  created: function created() {
    var _this = this;

    this.$api.order.findInvoice().then(function (response) {
      _this.invoices = response.data;
    });
  },

  methods: {
    invoiceDownload: function invoiceDownload(invoiceId) {
      this.$api.order.invoiceDownload({
        invoice_id: invoiceId
      });
    }
  }
});

/***/ }),

/***/ 324:
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_moment__);
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


__WEBPACK_IMPORTED_MODULE_0_moment___default.a.locale('de');

/* harmony default export */ __webpack_exports__["default"] = ({
  data: function data() {
    return {
      moment: __WEBPACK_IMPORTED_MODULE_0_moment___default.a,
      headers: [{
        text: 'Auftragsdatum',
        value: 'order_date'
      }, {
        text: 'Gerät',
        value: 'device',
        align: 'left'
      }, {
        text: 'Zubehör',
        value: 'accessoires',
        align: 'left'
      }, {
        text: 'Beschreibung',
        value: 'description',
        align: 'left'
      }, {
        text: 'Bemerkung',
        value: 'comment',
        align: 'left'
      }, {
        text: 'Status',
        value: 'state',
        align: 'left'
      }, {
        text: 'Beleg',
        sortable: false
      }],
      serviceorders: [],
      pagination: {
        sortBy: 'order_date',
        descending: true,
        rowsPerPage: 10
      }
    };
  },
  created: function created() {
    var _this = this;

    this.$api.service.findServiceOrder().then(function (response) {
      _this.serviceorders = response.data;
    });
  },

  methods: {
    invoiceDownload: function invoiceDownload(invoiceId) {
      this.$api.order.invoiceDownload({
        invoice_id: invoiceId
      });
    }
  }
});

/***/ }),

/***/ 568:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 573:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./af": 175,
	"./af.js": 175,
	"./ar": 182,
	"./ar-dz": 176,
	"./ar-dz.js": 176,
	"./ar-kw": 177,
	"./ar-kw.js": 177,
	"./ar-ly": 178,
	"./ar-ly.js": 178,
	"./ar-ma": 179,
	"./ar-ma.js": 179,
	"./ar-sa": 180,
	"./ar-sa.js": 180,
	"./ar-tn": 181,
	"./ar-tn.js": 181,
	"./ar.js": 182,
	"./az": 183,
	"./az.js": 183,
	"./be": 184,
	"./be.js": 184,
	"./bg": 185,
	"./bg.js": 185,
	"./bm": 186,
	"./bm.js": 186,
	"./bn": 187,
	"./bn.js": 187,
	"./bo": 188,
	"./bo.js": 188,
	"./br": 189,
	"./br.js": 189,
	"./bs": 190,
	"./bs.js": 190,
	"./ca": 191,
	"./ca.js": 191,
	"./cs": 192,
	"./cs.js": 192,
	"./cv": 193,
	"./cv.js": 193,
	"./cy": 194,
	"./cy.js": 194,
	"./da": 195,
	"./da.js": 195,
	"./de": 198,
	"./de-at": 196,
	"./de-at.js": 196,
	"./de-ch": 197,
	"./de-ch.js": 197,
	"./de.js": 198,
	"./dv": 199,
	"./dv.js": 199,
	"./el": 200,
	"./el.js": 200,
	"./en-au": 201,
	"./en-au.js": 201,
	"./en-ca": 202,
	"./en-ca.js": 202,
	"./en-gb": 203,
	"./en-gb.js": 203,
	"./en-ie": 204,
	"./en-ie.js": 204,
	"./en-nz": 205,
	"./en-nz.js": 205,
	"./eo": 206,
	"./eo.js": 206,
	"./es": 209,
	"./es-do": 207,
	"./es-do.js": 207,
	"./es-us": 208,
	"./es-us.js": 208,
	"./es.js": 209,
	"./et": 210,
	"./et.js": 210,
	"./eu": 211,
	"./eu.js": 211,
	"./fa": 212,
	"./fa.js": 212,
	"./fi": 213,
	"./fi.js": 213,
	"./fo": 214,
	"./fo.js": 214,
	"./fr": 217,
	"./fr-ca": 215,
	"./fr-ca.js": 215,
	"./fr-ch": 216,
	"./fr-ch.js": 216,
	"./fr.js": 217,
	"./fy": 218,
	"./fy.js": 218,
	"./gd": 219,
	"./gd.js": 219,
	"./gl": 220,
	"./gl.js": 220,
	"./gom-latn": 221,
	"./gom-latn.js": 221,
	"./gu": 222,
	"./gu.js": 222,
	"./he": 223,
	"./he.js": 223,
	"./hi": 224,
	"./hi.js": 224,
	"./hr": 225,
	"./hr.js": 225,
	"./hu": 226,
	"./hu.js": 226,
	"./hy-am": 227,
	"./hy-am.js": 227,
	"./id": 228,
	"./id.js": 228,
	"./is": 229,
	"./is.js": 229,
	"./it": 230,
	"./it.js": 230,
	"./ja": 231,
	"./ja.js": 231,
	"./jv": 232,
	"./jv.js": 232,
	"./ka": 233,
	"./ka.js": 233,
	"./kk": 234,
	"./kk.js": 234,
	"./km": 235,
	"./km.js": 235,
	"./kn": 236,
	"./kn.js": 236,
	"./ko": 237,
	"./ko.js": 237,
	"./ky": 238,
	"./ky.js": 238,
	"./lb": 239,
	"./lb.js": 239,
	"./lo": 240,
	"./lo.js": 240,
	"./lt": 241,
	"./lt.js": 241,
	"./lv": 242,
	"./lv.js": 242,
	"./me": 243,
	"./me.js": 243,
	"./mi": 244,
	"./mi.js": 244,
	"./mk": 245,
	"./mk.js": 245,
	"./ml": 246,
	"./ml.js": 246,
	"./mr": 247,
	"./mr.js": 247,
	"./ms": 249,
	"./ms-my": 248,
	"./ms-my.js": 248,
	"./ms.js": 249,
	"./my": 250,
	"./my.js": 250,
	"./nb": 251,
	"./nb.js": 251,
	"./ne": 252,
	"./ne.js": 252,
	"./nl": 254,
	"./nl-be": 253,
	"./nl-be.js": 253,
	"./nl.js": 254,
	"./nn": 255,
	"./nn.js": 255,
	"./pa-in": 256,
	"./pa-in.js": 256,
	"./pl": 257,
	"./pl.js": 257,
	"./pt": 259,
	"./pt-br": 258,
	"./pt-br.js": 258,
	"./pt.js": 259,
	"./ro": 260,
	"./ro.js": 260,
	"./ru": 261,
	"./ru.js": 261,
	"./sd": 262,
	"./sd.js": 262,
	"./se": 263,
	"./se.js": 263,
	"./si": 264,
	"./si.js": 264,
	"./sk": 265,
	"./sk.js": 265,
	"./sl": 266,
	"./sl.js": 266,
	"./sq": 267,
	"./sq.js": 267,
	"./sr": 269,
	"./sr-cyrl": 268,
	"./sr-cyrl.js": 268,
	"./sr.js": 269,
	"./ss": 270,
	"./ss.js": 270,
	"./sv": 271,
	"./sv.js": 271,
	"./sw": 272,
	"./sw.js": 272,
	"./ta": 273,
	"./ta.js": 273,
	"./te": 274,
	"./te.js": 274,
	"./tet": 275,
	"./tet.js": 275,
	"./th": 276,
	"./th.js": 276,
	"./tl-ph": 277,
	"./tl-ph.js": 277,
	"./tlh": 278,
	"./tlh.js": 278,
	"./tr": 279,
	"./tr.js": 279,
	"./tzl": 280,
	"./tzl.js": 280,
	"./tzm": 282,
	"./tzm-latn": 281,
	"./tzm-latn.js": 281,
	"./tzm.js": 282,
	"./uk": 283,
	"./uk.js": 283,
	"./ur": 284,
	"./ur.js": 284,
	"./uz": 286,
	"./uz-latn": 285,
	"./uz-latn.js": 285,
	"./uz.js": 286,
	"./vi": 287,
	"./vi.js": 287,
	"./x-pseudo": 288,
	"./x-pseudo.js": 288,
	"./yo": 289,
	"./yo.js": 289,
	"./zh-cn": 290,
	"./zh-cn.js": 290,
	"./zh-hk": 291,
	"./zh-hk.js": 291,
	"./zh-tw": 292,
	"./zh-tw.js": 292
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 573;

/***/ }),

/***/ 576:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(48)(
  /* script */
  __webpack_require__(319),
  /* template */
  __webpack_require__(588),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 577:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(48)(
  /* script */
  __webpack_require__(320),
  /* template */
  __webpack_require__(589),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 578:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(48)(
  /* script */
  __webpack_require__(321),
  /* template */
  __webpack_require__(585),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 579:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(48)(
  /* script */
  __webpack_require__(322),
  /* template */
  __webpack_require__(586),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 580:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(48)(
  /* script */
  __webpack_require__(323),
  /* template */
  __webpack_require__(583),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 581:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(48)(
  /* script */
  null,
  /* template */
  __webpack_require__(587),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 582:
/***/ (function(module, exports, __webpack_require__) {

var Component = __webpack_require__(48)(
  /* script */
  __webpack_require__(324),
  /* template */
  __webpack_require__(584),
  /* styles */
  null,
  /* scopeId */
  null,
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports


/***/ }),

/***/ 583:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', [_c('h1', [_vm._v("Ihre Einkäufe")]), _vm._v(" "), _c('v-container', [_c('v-data-table', {
    staticClass: "elevation-3",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.invoices,
      "pagination": _vm.pagination,
      "rows-per-page-text": 'Aufträge pro Seite',
      "no-data-text": 'Keine Aufträge vorhanden'
    },
    on: {
      "update:pagination": function($event) {
        _vm.pagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', {
          staticClass: "text-xs-right"
        }, [_vm._v(_vm._s(_vm.moment(props.item.invoice_date).format('L')))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_vm._v(_vm._s(props.item.invoice_nr))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.invoice_type == 2 ? 'Kassenbon' : 'Rechnung'))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_vm._v(_vm._s(props.item.total.replace('.', ',')) + " €")]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [_c('a', {
          on: {
            "click": function($event) {
              _vm.invoiceDownload(props.item.invoice_id)
            }
          }
        }, [_vm._v("herunterladen")])])]
      }
    }])
  })], 1), _vm._v(" "), _c('h2', [_vm._v("Fehlt ein Einkauf?")]), _vm._v(" "), _c('v-container', [_vm._v("\n    Bitte Kassenbon-Nummer eintragen:"), _c('br'), _vm._v(" oder schreiben Sie uns eine Nachricht:"), _c('br')])], 1)
},staticRenderFns: []}

/***/ }),

/***/ 584:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', [_c('h1', [_vm._v("Werkstattaufträge")]), _vm._v(" "), _c('p', [_vm._v("Hier sehen Sie, welche Geräte Sie bei uns in der Werkstatt hatten.")]), _vm._v(" "), _c('v-data-table', {
    staticClass: "elevation-3",
    attrs: {
      "headers": _vm.headers,
      "items": _vm.serviceorders,
      "pagination": _vm.pagination,
      "rows-per-page-text": 'Aufträge pro Seite',
      "no-data-text": 'Keine Aufträge vorhanden'
    },
    on: {
      "update:pagination": function($event) {
        _vm.pagination = $event
      }
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', {
          staticClass: "text-xs-right"
        }, [_vm._v(_vm._s(_vm.moment(props.item.order_date).format('L')))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.device))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.accessoires))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.description))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.comment))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(props.item.state))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right"
        }, [(props.item.invoice) ? _c('a', {
          on: {
            "click": function($event) {
              _vm.invoiceDownload(props.item.invoice.invoice_id)
            }
          }
        }, [_vm._v("herunterladen")]) : _vm._e()])]
      }
    }])
  })], 1)
},staticRenderFns: []}

/***/ }),

/***/ 585:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-tabs', {
    attrs: {
      "fixed": "",
      "centered": ""
    }
  }, [_c('v-tabs-bar', {
    staticClass: "blue lighten-1",
    attrs: {
      "dark": ""
    }
  }, [_c('v-tabs-slider', {
    staticClass: "yellow"
  }), _vm._v(" "), _vm._l((_vm.items), function(item, i) {
    return _c('v-tabs-item', {
      key: i,
      attrs: {
        "href": '#tab-' + i
      }
    }, [_vm._v("\n      " + _vm._s(item.text) + "\n    ")])
  })], 2), _vm._v(" "), _c('v-tabs-items', [_c('v-tabs-content', {
    attrs: {
      "id": "tab-0"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    attrs: {
      "primary-title": ""
    }
  }, [_vm._v("Ihre Zugangsdaten zum Online-Portal")]), _vm._v(" "), _c('v-card-text', [_c('v-text-field', {
    attrs: {
      "label": "Benutzername"
    },
    model: {
      value: (_vm.account.username),
      callback: function($$v) {
        _vm.$set(_vm.account, "username", $$v)
      },
      expression: "account.username"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "E-Mail-Adresse"
    },
    model: {
      value: (_vm.account.email),
      callback: function($$v) {
        _vm.$set(_vm.account, "email", $$v)
      },
      expression: "account.email"
    }
  }), _vm._v(" "), _c('v-checkbox', {
    attrs: {
      "label": "Passwort ändern"
    },
    model: {
      value: (_vm.account.changepwd),
      callback: function($$v) {
        _vm.$set(_vm.account, "changepwd", $$v)
      },
      expression: "account.changepwd"
    }
  }), _vm._v(" "), (_vm.account.changepwd) ? _c('v-text-field', {
    attrs: {
      "label": "Passwort",
      "append-icon": _vm.e1 ? 'visibility' : 'visibility_off',
      "append-icon-cb": function () { return (_vm.e1 = !_vm.e1); },
      "type": _vm.e1 ? 'password' : 'text',
      "required": ""
    },
    model: {
      value: (_vm.account.password),
      callback: function($$v) {
        _vm.$set(_vm.account, "password", $$v)
      },
      expression: "account.password"
    }
  }) : _vm._e()], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary",
      "flat": ""
    },
    on: {
      "click": _vm.updateAccount
    }
  }, [_vm._v("Speichern")])], 1)], 1)], 1), _vm._v(" "), _c('v-tabs-content', {
    attrs: {
      "id": "tab-1"
    }
  }, [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    attrs: {
      "primary-title": ""
    }
  }, [_vm._v("Kundendaten bearbeiten")]), _vm._v(" "), _c('v-card-text')], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 586:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm12": "",
      "md12": ""
    }
  }, [_vm._l((_vm.messages), function(message) {
    return [(!_vm.activeMessage || _vm.activeMessage === message) ? _c('v-container', {
      key: message.message_id
    }, [_c('v-card', [_c('v-card-title', [_c('h3', [_vm._v(_vm._s(message.message_title))])]), _vm._v(" "), _c('v-card-text', {
      staticClass: "grey lighten-5",
      staticStyle: {
        "overflow": "auto"
      },
      domProps: {
        "innerHTML": _vm._s(message.message_body ? message.message_body.message_body : '')
      }
    }), _vm._v(" "), (!_vm.activeMessage) ? _c('v-card-text', {
      staticClass: "grey lighten-5"
    }, [(message.replies.length) ? _c('v-btn', {
      attrs: {
        "flat": ""
      },
      on: {
        "click": function($event) {
          _vm.activeMessage = message
        }
      }
    }, [_vm._v(_vm._s(message.replies.length) + " Antworten")]) : _vm._e(), _vm._v(" "), _c('v-btn', {
      attrs: {
        "color": "blue",
        "fab": "",
        "dark": "",
        "small": "",
        "absolute": "",
        "bottom": "",
        "right": ""
      }
    }, [_c('v-icon', [_vm._v("menu")])], 1)], 1) : _vm._e()], 1)], 1) : _vm._e()]
  }), _vm._v(" "), (_vm.activeMessage) ? _vm._l((_vm.activeMessage.replies), function(msg) {
    return _c('v-container', {
      key: msg.message_id
    }, [_c('v-card', [_c('v-card-title', [_c('h3', [_vm._v(_vm._s(msg.message_title))])]), _vm._v(" "), _c('v-card-text', {
      staticClass: "grey lighten-5",
      staticStyle: {
        "overflow": "auto"
      },
      domProps: {
        "innerHTML": _vm._s(msg.message_body ? msg.message_body.message_body : '')
      }
    })], 1)], 1)
  }) : _vm._e(), _vm._v(" "), _c('v-container', [_c('v-card', [_c('v-card-title', [_c('h3', [_vm._v(_vm._s(_vm.activeMessage ? 'Antwort' : 'Nachricht') + " verfassen")])]), _vm._v(" "), _c('v-card-text', [_c('v-text-field', {
    attrs: {
      "placeholder": "Betreff"
    },
    model: {
      value: (_vm.title),
      callback: function($$v) {
        _vm.title = $$v
      },
      expression: "title"
    }
  })], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "grey lighten-5"
  }, [_c('vue-editor', {
    attrs: {
      "editorToolbar": _vm.customToolbar
    },
    model: {
      value: (_vm.text),
      callback: function($$v) {
        _vm.text = $$v
      },
      expression: "text"
    }
  })], 1), _vm._v(" "), _c('v-card-text', {
    staticClass: "grey lighten-5"
  }, [_c('v-btn', {
    attrs: {
      "color": "blue",
      "fab": "",
      "dark": "",
      "small": "",
      "absolute": "",
      "bottom": "",
      "right": ""
    },
    on: {
      "click": _vm.sendMessage
    }
  }, [_c('v-icon', [_vm._v("send")])], 1)], 1)], 1)], 1)], 2)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 587:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    attrs: {
      "grid-list-md": "",
      "text-xs-center": "",
      "fluid": ""
    }
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "d-flex": "",
      "xs12": "",
      "sm6": "",
      "md4": "",
      "lg3": ""
    }
  }, [_c('img', {
    staticClass: "ma-2",
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "src": "static/img/start.jpg"
    }
  })]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "d-flex": "",
      "xs12": "",
      "sm6": "",
      "md8": "",
      "lg9": "",
      "text-xs-left": ""
    }
  }, [_c('div', {
    staticClass: "ma-2"
  }, [_c('h1', [_vm._v("Willkommen " + _vm._s(_vm.$appData.account.username))]), _vm._v(" zu Ihrem persönlichen Online-Kundenservice\n      ")])]), _vm._v(" "), _c('v-flex', {
    attrs: {
      "d-flex": "",
      "xs12": "",
      "sm6": "",
      "md4": "",
      "lg6": ""
    }
  }, [_c('v-card', {
    staticClass: "ma-2"
  }, [_c('v-card-title', [_c('h1', [_vm._v("Cashback-Programm")])]), _vm._v(" "), _c('v-card-text', [_vm._v("Ihr Cashback-Guthaben beträgt zur Zeit 10,00€")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "d-flex": "",
      "xs12": "",
      "sm6": "",
      "md4": "",
      "lg3": ""
    }
  }, [_c('v-card', {
    staticClass: "ma-2"
  }, [_c('v-card-title', [_c('h1', [_vm._v("Cashback-Programm")])]), _vm._v(" "), _c('v-card-text', [_vm._v("Ihr Cashback-Guthaben beträgt zur Zeit 10,00€ Ihr Cashback-Guthaben beträgt zur Zeit 10,00€ Ihr Cashback-Guthaben beträgt zur Zeit 10,00€ Ihr Cashback-Guthaben beträgt zur Zeit 10,00€ Ihr Cashback-Guthaben beträgt zur Zeit 10,00€\n        ")])], 1)], 1), _vm._v(" "), _c('v-flex', {
    attrs: {
      "d-flex": "",
      "xs12": "",
      "sm6": "",
      "md4": "",
      "lg3": ""
    }
  }, [_c('v-card', {
    staticClass: "ma-2"
  }, [_c('v-card-title', [_c('h1', [_vm._v("Cashback-Programm")])]), _vm._v(" "), _c('v-card-text', [_vm._v("Ihr Cashback-Guthaben beträgt zur Zeit 10,00€")])], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 588:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-app', [(_vm.isLoggedIn && !_vm.error) ? _c('v-navigation-drawer', {
    attrs: {
      "fixed": "",
      "mini-variant": _vm.miniVariant,
      "clipped": true,
      "app": ""
    },
    model: {
      value: (_vm.drawer),
      callback: function($$v) {
        _vm.drawer = $$v
      },
      expression: "drawer"
    }
  }, [_c('v-list', [_vm._l((_vm.items), function(item, i) {
    return _c('v-list-tile', {
      key: i,
      attrs: {
        "to": item.link,
        "value": "true",
        "exact": "",
        "activeClass": ""
      }
    }, [_c('v-list-tile-action', [_c('v-icon', {
      domProps: {
        "innerHTML": _vm._s(item.icon)
      }
    })], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
      domProps: {
        "textContent": _vm._s(item.title)
      }
    })], 1)], 1)
  }), _vm._v(" "), _c('v-list-tile', {
    attrs: {
      "activeClass": ""
    },
    on: {
      "click": _vm.logout
    }
  }, [_c('v-list-tile-action', [_c('v-icon', {
    domProps: {
      "innerHTML": _vm._s('exit_to_app')
    }
  })], 1), _vm._v(" "), _c('v-list-tile-content', [_c('v-list-tile-title', {
    domProps: {
      "textContent": _vm._s('Abmelden')
    }
  })], 1)], 1)], 2)], 1) : _vm._e(), _vm._v(" "), (_vm.isLoggedIn && !_vm.error) ? _c('v-toolbar', {
    attrs: {
      "fixed": "",
      "app": "",
      "clipped-left": true
    }
  }, [_c('v-toolbar-side-icon', {
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.drawer = !_vm.drawer
      }
    }
  }), _vm._v(" "), _c('v-toolbar-title', {
    domProps: {
      "textContent": _vm._s(_vm.title)
    }
  }), _vm._v(" "), _c('v-spacer')], 1) : _vm._e(), _vm._v(" "), (_vm.isLoggedIn && !_vm.error) ? _c('v-content', [_c('router-view')], 1) : _vm._e(), _vm._v(" "), (_vm.isLoggedIn && !_vm.error) ? _c('v-footer', {
    attrs: {
      "fixed": _vm.fixed,
      "app": ""
    }
  }, [_c('span', [_vm._v("© 2017")])]) : _vm._e(), _vm._v(" "), (!_vm.isLoggedIn && !_vm.error) ? _c('v-content', [_c('v-login')], 1) : _vm._e(), _vm._v(" "), (_vm.error) ? _c('v-content', [_c('v-dialog', {
    attrs: {
      "value": true,
      "persistent": "",
      "max-width": "350"
    }
  }, [_c('v-card', [_c('v-card-text', [_vm._v(_vm._s(_vm.error.message))]), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.closeError
    }
  }, [_vm._v("OK")])], 1)], 1)], 1)], 1) : _vm._e()], 1)
},staticRenderFns: []}

/***/ }),

/***/ 589:
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-dialog', {
    attrs: {
      "value": true,
      "persistent": "",
      "max-width": "350"
    }
  }, [_c('v-tabs', {
    attrs: {
      "grow": ""
    },
    model: {
      value: (_vm.$appData.login_selected_tab),
      callback: function($$v) {
        _vm.$set(_vm.$appData, "login_selected_tab", $$v)
      },
      expression: "$appData.login_selected_tab"
    }
  }, [_c('v-tabs-bar', {
    staticClass: "blue lighten-1"
  }, [_c('v-tabs-item', {
    attrs: {
      "href": '#login',
      "ripple": ""
    }
  }, [_vm._v("\n        Anmelden\n      ")]), _vm._v(" "), _c('v-tabs-item', {
    attrs: {
      "href": '#register',
      "ripple": ""
    }
  }, [_vm._v("\n        Registrieren\n      ")]), _vm._v(" "), _c('v-tabs-slider', {
    attrs: {
      "color": "indigo darken-2"
    }
  })], 1), _vm._v(" "), _c('v-tabs-items', [_c('v-tabs-content', {
    attrs: {
      "id": 'login'
    }
  }, [_c('v-card', {
    staticStyle: {
      "background": "white"
    },
    attrs: {
      "hover": ""
    }
  }, [_c('v-card-text', {
    staticClass: "pt-4"
  }, [_c('v-form', {
    attrs: {
      "action": "login",
      "submitButtonText": "Login"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "Benutzername oder E-Mail-Adresse",
      "required": ""
    },
    model: {
      value: (_vm.$appData.account.username),
      callback: function($$v) {
        _vm.$set(_vm.$appData.account, "username", $$v)
      },
      expression: "$appData.account.username"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Passwort",
      "append-icon": _vm.e1 ? 'visibility' : 'visibility_off',
      "append-icon-cb": function () { return (_vm.e1 = !_vm.e1); },
      "type": _vm.e1 ? 'password' : 'text',
      "required": ""
    },
    model: {
      value: (_vm.$appData.account.password),
      callback: function($$v) {
        _vm.$set(_vm.$appData.account, "password", $$v)
      },
      expression: "$appData.account.password"
    }
  }), _vm._v(" "), _c('v-flex', {
    staticClass: "pb-2"
  }, [_c('small', [_vm._v("* Eingabe erforderlich")])])], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.login
    }
  }, [_vm._v("Login")])], 1)], 1)], 1), _vm._v(" "), _c('v-tabs-content', {
    attrs: {
      "id": 'register'
    }
  }, [_c('v-card', {
    staticStyle: {
      "background": "white"
    },
    attrs: {
      "hover": ""
    }
  }, [_c('v-card-text', {
    staticClass: "pt-4"
  }, [_c('v-form', {
    attrs: {
      "action": "login",
      "submitButtonText": "Login"
    }
  }, [_c('v-text-field', {
    attrs: {
      "label": "gewünschter Benutzername",
      "required": ""
    },
    model: {
      value: (_vm.$appData.account.username),
      callback: function($$v) {
        _vm.$set(_vm.$appData.account, "username", $$v)
      },
      expression: "$appData.account.username"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "E-Mail-Adresse",
      "required": ""
    },
    model: {
      value: (_vm.$appData.account.email),
      callback: function($$v) {
        _vm.$set(_vm.$appData.account, "email", $$v)
      },
      expression: "$appData.account.email"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "gewünschtes Passwort",
      "append-icon": _vm.e1 ? 'visibility' : 'visibility_off',
      "append-icon-cb": function () { return (_vm.e1 = !_vm.e1); },
      "type": _vm.e1 ? 'password' : 'text',
      "required": ""
    },
    model: {
      value: (_vm.$appData.account.password),
      callback: function($$v) {
        _vm.$set(_vm.$appData.account, "password", $$v)
      },
      expression: "$appData.account.password"
    }
  }), _vm._v("\n              Damit wir den Zugang zuordnen können, geben Sie bitte folgende Informationen an:\n              "), _c('v-text-field', {
    attrs: {
      "label": "Name"
    },
    model: {
      value: (_vm.$appData.account.name),
      callback: function($$v) {
        _vm.$set(_vm.$appData.account, "name", $$v)
      },
      expression: "$appData.account.name"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Telefon"
    },
    model: {
      value: (_vm.$appData.account.phone),
      callback: function($$v) {
        _vm.$set(_vm.$appData.account, "phone", $$v)
      },
      expression: "$appData.account.phone"
    }
  }), _vm._v("\n              Wenn Sie möchten, können Sie die folgenden Felder ausfüllen. Sollten die Daten mit unserem System übereinstimmen, wird Ihr Zugang automatisch freigeschaltet.\n              "), _c('v-text-field', {
    attrs: {
      "label": "Kundennummer"
    },
    model: {
      value: (_vm.$appData.account.customer_nr),
      callback: function($$v) {
        _vm.$set(_vm.$appData.account, "customer_nr", $$v)
      },
      expression: "$appData.account.customer_nr"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Rechnungsnummer"
    },
    model: {
      value: (_vm.$appData.account.invoice_nr),
      callback: function($$v) {
        _vm.$set(_vm.$appData.account, "invoice_nr", $$v)
      },
      expression: "$appData.account.invoice_nr"
    }
  }), _vm._v(" "), _c('v-menu', {
    attrs: {
      "lazy": "",
      "close-on-content-click": false,
      "transition": "scale-transition",
      "offset-y": "",
      "full-width": "",
      "nudge-right": 40,
      "max-width": "290px",
      "min-width": "290px"
    },
    model: {
      value: (_vm.menu),
      callback: function($$v) {
        _vm.menu = $$v
      },
      expression: "menu"
    }
  }, [_c('v-text-field', {
    attrs: {
      "slot": "activator",
      "label": "Rechnungsdatum"
    },
    on: {
      "blur": function($event) {
        _vm.date = _vm.parseDate(_vm.$appData.account.invoice_date)
      }
    },
    slot: "activator",
    model: {
      value: (_vm.$appData.account.invoice_date),
      callback: function($$v) {
        _vm.$set(_vm.$appData.account, "invoice_date", $$v)
      },
      expression: "$appData.account.invoice_date"
    }
  }), _vm._v(" "), _c('v-date-picker', {
    attrs: {
      "locale": "de-DE",
      "no-title": "",
      "scrollable": "",
      "actions": "",
      "autosave": ""
    },
    on: {
      "input": function($event) {
        _vm.$appData.account.invoice_date = _vm.formatDate($event)
      }
    },
    model: {
      value: (_vm.date),
      callback: function($$v) {
        _vm.date = $$v
      },
      expression: "date"
    }
  })], 1), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Rechnungsbetrag"
    },
    model: {
      value: (_vm.$appData.account.invoice_total),
      callback: function($$v) {
        _vm.$set(_vm.$appData.account, "invoice_total", $$v)
      },
      expression: "$appData.account.invoice_total"
    }
  }), _vm._v(" "), _c('v-flex', {
    staticClass: "pb-2"
  }, [_c('small', [_vm._v("* Eingabe erforderlich")])])], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.register
    }
  }, [_vm._v("Jetzt registrieren")])], 1)], 1)], 1)], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),

/***/ 595:
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(295);
module.exports = __webpack_require__(294);


/***/ })

},[595]);


// WEBPACK FOOTER //
// static/js/app.d0db00d34e9141f9e391.js